<div *ngIf="showCampSiteBanner" class="campsite-banner">This is a CampSite Camp, so some editing must be done in the CampSite portal.</div>

<div class="section-host">
    <div class="section-host-left" *ngIf="deviceManager.isWideEnoughForDualPane || !showRightPane">
        <div class="left-pane-toolbar">
            <ng-container [ngTemplateOutlet]="leftToolbar"></ng-container>
        </div>
        <div class="section-host-left-body">
            <ng-container [ngTemplateOutlet]="leftPaneBody"></ng-container>
        </div>
    </div>

    <div *ngIf="showRightPane" class="section-host-right">
        <ng-container [ngTemplateOutlet]="rightPaneBody"></ng-container>
    </div>
</div>

<mycampapp-waiting-indicator *ngIf="busy" [@fadeInOut] ></mycampapp-waiting-indicator>

